import React, { useState } from "react";
import OrdersModal from "components/profile/orders/orders-modal";
import { Spinner } from "react-bootstrap";
import { hasActive } from "payment-provider/inovio/inovio";
import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import { fetchOrders, getOrdersState } from "state/slices/user-orders-slice.ts";

const MyOrdersButton = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useAppDispatch();

  const orders = useAppSelector(getOrdersState).orders;

  const handleOpen = () => {
    dispatch(fetchOrders());
    setShowModal(true);
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center m-2 position-relative">
        <div
          style={{
            color: "white",
            background: "transparent",
            cursor: "pointer",
            border: "none",
            fontSize: 18,
            fontStyle: "italic",
            textDecoration: "underline",
          }}
          onClick={handleOpen}
        >
          Deposit History
        </div>
        {hasActive(orders) && (
          <Spinner
            animation="border"
            style={{
              borderWidth: "2px",
              color: "white",
              width: "20px",
              height: "20px",
              marginLeft: "3rem",
              position: "absolute",
              right: "-25px",
            }}
          />
        )}
      </div>
      <OrdersModal show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
};

export default MyOrdersButton;
